import { QRCodeSVG } from 'qrcode.react';
import { useState, useEffect } from 'react';

import useTranslate from '@/hooks/useTranslate';
import Heading from '@/ui/members/components/Heading';
import Spinner from '@/ui/members/components/Spinner';

import { useGetOneTimeToken } from '../../hooks/useGetOneTimeToken';
import GradientBg from '../../pages/Onboarding/components/GradientBg';
import MobileAppLink from '../MobileAppLink';

const FALLBACK_DOWNLOAD_SCHEDULE_URL = `${process.env.VITE_APP_WEBSITE_URL}/download-and-schedule`;

export const DownloadToGetStarted = () => {
  const {
    refetch: refetchOneTimeToken,
    isPending: oneTimeTokenPending,
    isRefetching: oneTimeTokenRefetching
  } = useGetOneTimeToken({});

  const [loginLink, setLoginLink] = useState<string>('');

  const { t } = useTranslate('pages.members.pages.DownloadToGetStarted');

  useEffect(() => {
    refetchOneTimeToken()
      .then((response) => {
        setLoginLink(response.data?.link || FALLBACK_DOWNLOAD_SCHEDULE_URL);
      })
      .catch(() => {
        setLoginLink(FALLBACK_DOWNLOAD_SCHEDULE_URL);
      });
  }, [refetchOneTimeToken]);

  return (
    <div className="flex flex-col items-center max-w-md m-auto px-4 py-12 h-full">
      <Heading
        value={1}
        text={t('downloadApp')}
        className="mb-6 text-center text-4xl md:text-5xl max-w-70"
      />
      <GradientBg imgClassName="w-80 sm:w-96 md:w-130 max-w-130 z-0 left-1/2 -translate-x-1/2 top-[-50%] rotate-180 abs">
        <div className="flex flex-col items-center gap-6 mb-8">
          <MobileAppLink store="google" />
          <MobileAppLink store="apple" />
        </div>
      </GradientBg>

      <div className="relative flex flex-col items-center justify-center min-h-50">
        {oneTimeTokenPending || oneTimeTokenRefetching ? (
          <Spinner className="mb-8 p-12" visibleLabel={false} size={20} />
        ) : (
          <QRCodeSVG
            className="rounded-lg border-8 border-uniform-white-base hidden sm:block mb-8 text-center m-auto"
            value={`${loginLink}?next=%2Fnavigate%2FHome`}
            size={180}
          />
        )}
      </div>
    </div>
  );
};
